module.exports = __webpack_public_path__ + "_assets/img/space.7d7e9b3d.svg";